/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ILinks {
  linkDescription?: string;
  downloadLink?: string;
}

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  links: ILinks[];
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'WWE coloring & activity Sheets',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDsCF',
    textDescription:
      'Kane, Randy Orton, or The Rock! Who is their favorite character? Discover that after bringing all the coloring sheets on the table! Let them rock it with colors red, yellow, black, or by adding some metallic colors to the belts, they will shine!<br/><br/>Printer, go… crayons, go… go, go “Your accomplishments are endless.”!<br/><br/>Parents,use #LetsPlaySaudi on social media so we can see how they did it!<br/><br/>',
    links: [
      {
        linkDescription: 'Puzzles ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1Usb',
      },
      {
        linkDescription: 'Coloring Sheets ',
        downloadLink:
          'https://www.toysrus.com.sa/content/files/images/Printables/wwe_2.pdf',
      },
      {
        linkDescription: 'Spot The Difference ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1XsY',
      },
      {
        linkDescription: 'Download Answer ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1Xt0',
      },
    ],
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>

            <div className='table-container'>
              <table className='table'>
                {this.printPage.links.map((item) => (
                  <tr>
                    <td>{item.linkDescription}</td>
                    <td>
                      <a href={item.downloadLink} className='print-download-link' target='_blank'>download
                      </a>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
